<p-card class="p-card container">
  <h3 i18n>Questionnaires supplémentaires</h3>

  @if (extraQuestionnaires.length > 0) {
    <div class="flex flex-wrap gap-3">
      @for (questionnaire of extraQuestionnaires; track questionnaire; let questionnaireIndex = $index) {
        <div class="layout__inner-card w-full">
          <div class="flex justify-content-between">
            <h3>{{ questionnaire.title }}</h3>
            @if (questionnaire.completedAt) {
              <p class="text-xl text-800" i18n
                >Date complétée : <strong>{{ questionnaire.completedAt | date: 'longDate' }}</strong></p
              >
            }
          </div>
          @if (questionnaire.presetQuestions) {
            @for (
              question of questionnaire.presetQuestions;
              track question;
              let i = $index;
              let last = $last
            ) {
              <div class="flex">
                <div class="mr-2">{{ i + 1 }}.</div>
                <div class="flex-grow-1">
                  <em-question
                    [question]="question"
                    [control]="
                      getFormControl(questionnaireIndex, question.answer.propertyName)
                    "></em-question>
                  @if (!last) {
                    <p-divider></p-divider>
                  }
                </div>
              </div>
            }
          }
          @if (questionnaire.type === healthAnswersRevisionType.CUSTOM && questionnaire.customQuestion) {
            <div class="flex flex-wrap flex-column gap-3">
              <div *ngIf="isFFEnabled" class="flex justify-content-between w-full items-center">
                <p class="m-0" [innerHTML]="questionnaire.customQuestion.text | emMarkdown"></p>
                @if (canModifyIsIncludedInContract) {
                  <p-checkbox
                    class="flex flex-row-reverse gap-2"
                    i18n-label
                    label="Ajouter au contrat"
                    [(ngModel)]="questionnaire.isIncludedInContract"
                    binary="true"
                    [disabled]="isReadonly"
                    (onChange)="onUpdateIsIncludedInContract($event, questionnaire.revisionId)">
                  </p-checkbox>
                }
              </div>

              <div *ngIf="!isFFEnabled" class="flex justify-content-between w-full items-center">
                <p class="m-0" [innerHTML]="questionnaire.customQuestion.text | emMarkdown"></p>
              </div>
              @if (getFormControl(questionnaireIndex, customControlName).enabled) {
                <div class="col-12">
                  <div class="p-0 flex flex-column gap-4">
                    <textarea
                      class="w-full"
                      pInputTextarea
                      [formControl]="getFormControl(questionnaireIndex, customControlName)"
                      [maxlength]="5000"
                      i18n-placeholder
                      placeholder="Écrire la réponse"
                      rows="4"></textarea>
                    <p-fileUpload
                      id="dont-show-file-bytes"
                      (onSelect)="onSelectDocuments($event, questionnaireIndex)"
                      (onRemove)="onRemoveDocument($event, questionnaireIndex)"
                      [multiple]="true"
                      [files]="getFormControl(questionnaireIndex, documentsControlName).value || []"
                      [customUpload]="true"
                      [auto]="true"
                      [maxFileSize]="5000000"
                      [invalidFileSizeMessageSummary]="
                        translate.currentLanguageIsFr() ? 'Taille du fichier invalide' : 'Invalid file size'
                      "
                      [invalidFileSizeMessageDetail]="''"
                      [fileLimit]="4"
                      accept=".pdf"
                      i18n-chooseLabel
                      chooseLabel="Choisir">
                    </p-fileUpload>
                  </div>
                </div>
              }
              @if (getFormControl(questionnaireIndex, customControlName).disabled) {
                <p-card
                  class="card__eq"
                  [ngClass]="
                    getFormControl(questionnaireIndex, customControlName).value
                      ? 'card__eq--enabled'
                      : 'card__eq--disabled'
                  ">
                  <div class="flex flex-column gap-5">
                    @if (getFormControl(questionnaireIndex, customControlName).value) {
                      <div class="flex gap-3"
                        ><b i18n>Réponse :</b>
                        <p
                          [innerHTML]="
                            getFormControl(questionnaireIndex, customControlName).value | emMarkdown
                          "></p
                      ></div>
                    }
                    @if (!getFormControl(questionnaireIndex, customControlName).value) {
                      <p class="opacity-50" i18n>En attente de la réponse...</p>
                    }
                    @if (getFormControl(questionnaireIndex, documentsControlName).value) {
                      <div>
                        <p class="text-sm" i18n>Pièces jointes</p>
                        <div class="flex gap-3">
                          @for (
                            document of getFormControl(questionnaireIndex, documentsControlName).value;
                            track document
                          ) {
                            <p-button
                              (onClick)="onDownloadDocument(document.name, questionnaireIndex)"
                              class="btn--light-grey"
                              type="button"
                              [label]="document.name"
                              icon="pi pi-file-pdf"></p-button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </p-card>
              }
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <i class="text-600" i18n>Aucun questionnaire supplémentaire.</i>
  }

  @if (isFFEnabled) {
    @if (!allExtraQuestionnairesCompleted && !isReadonly && canAnswerQuestions) {
      <p-button
        class="flex justify-content-center mt-6"
        [disabled]="!form.valid || isPendingUpdate"
        i18n-label
        label="Confirmer les réponses"
        icon="pi pi-check"
        [loading]="isLoading"
        (onClick)="completeExtraQuestionnaires()"></p-button>
    }
  } @else {
    @if (!allExtraQuestionnairesCompleted && !isReadonly) {
      <p-button
        class="flex justify-content-center mt-6"
        [disabled]="!form.valid || isPendingUpdate"
        i18n-label
        label="Confirmer les réponses"
        icon="pi pi-check"
        [loading]="isLoading"
        (onClick)="completeExtraQuestionnaires()"></p-button>
    }
  }
</p-card>
